export const columns = [
  {
    field: 'no',
    headerName: 'examPreviewResultQuestionScoreTable.column.no',
    align: 'left',
    cellClassName: 'w-15',
  },
  {
    field: 'qid',
    headerName: 'examPreviewResultQuestionScoreTable.column.qid',
    align: 'left',
    cellClassName: 'flex-1',
  },
  {
    field: 'scorePerQuestion',
    headerName: 'examPreviewResultQuestionScoreTable.column.scorePerQuestion',
    align: 'left',
    cellClassName: 'w-40',
  },
  {
    field: 'correctAnswer',
    headerName: 'examPreviewResultQuestionScoreTable.column.correctAnswer',
    align: 'left',
    cellClassName: 'w-40',
  },
  {
    field: 'selectedAnswer',
    headerName: 'examPreviewResultQuestionScoreTable.column.selectedAnswer',
    align: 'left',
    cellClassName: 'w-40',
  },
  {
    field: 'result',
    headerName: 'examPreviewResultQuestionScoreTable.column.result',
    align: 'left',
    cellClassName: 'w-40',
  },
];
